<template>
  <div @closeclick="cloture()">
    <div class="card modal-card-border infoWindowMap">
      <div class="card-content">
        <div :key="index" v-for="(p, index) in marker.panneaux"
             v-if="index === marker.indexPanneauCourant">
          <div class="columns">
            <div class="column is-11">
              <h1 class="is-5">
                <span class="subtitle">
                  Emplacement
                </span>
                <span class="title is-5">{{p.namePlace}}</span>
              </h1>
              <p class="subtitle is-7" v-if="p.codeFaces">
                Spot(s) : {{p.codeFaces}}
              </p>
            </div>
          </div>
          <div class="columns detail-component">
            <div class="column is-5">
              <img :src="p.urlPhoto"
                   v-if="p.urlPhoto"
                   style="max-height:220px">
              <img v-else :src="p.img">
              <span class="pagination-link is-current distance">{{marker.distance}} km</span>
            </div>
            <div class="column is-8">
              <h1 class="subtitle is-6 information-title">Informations</h1>
              <div class="columns">
                <div class="column is-6">
                  <p class="information">Adresse commerciale</p>
                  <span>{{p.adresse1}}</span>
                  <span v-if="p.adresse2">{{p.adresse2}} </span>
                  <span v-if="p.adresse3">{{p.adresse3}} </span>
                  <span>{{p.ville}}</span>
                  <br>
                  <p class="information">Format</p>
                  <span>{{p.format}}</span>
                  <br>
                  <p class="information">Matériel</p>
                  <span>{{p.materiel}}</span>
                  <br>
                </div>
                <div class="column is-6">
                  <p class="information">En venant de</p>
                  <span>{{p.enVenantDe}}</span>
                  <br>
                  <p class="information">En allant vers</p>
                  <span>{{p.enAllantVers}}</span>
                  <br>
                  <p class="information">Eclairé</p>
                  <span>{{p.eclaire}}</span>
                  <br>
                </div>
              </div>
            </div>
            <div class="column is-4">
            </div>
          </div>
          <div class="column is-5 is-paddingless mb-10">
            <b-button type="is-primary"
                      icon-left="file-pdf"
                      expanded @click="download(p.panneauOrigine)">
              Télécharger la fiche produit
            </b-button>
          </div>
          <app-liste-affectations :panneau="p"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import * as niveauDispo from '@/components/creationOpportunite/configuration/DisponibiliteConf';
import gestionErreur from '@/services/general/gestionErreur';
import { getFichePdf } from '@/api/panneauxNumeriques';
import ListeAffectations from './listeAffectations';

const Numerique = createNamespacedHelpers('venteNumerique');

export default {
  name: 'info-window-map',
  props: ['marker'],
  components: {
    appListeAffectations: ListeAffectations,
  },
  data() {
    return {
      niveauPasDefini: niveauDispo.DISPONIBILITE_INDEFINI,
      produitSelect: {},
    };
  },
  computed: {
    ...Numerique.mapGetters({
      dateStart: 'dateStart',
      dateEnd: 'dateEnd',
    }),
  },
  methods: {
    cloture() {
      this.$emit('closeInfoWindow');
    },
    async download(data) {
      this.produitSelect = cloneDeep(data);
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        const resp = await getFichePdf(this.produitSelect);
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(resp.data);
        const disposition = resp.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
      } catch (e) {
        gestionErreur(`Erreur lors de l'impression de la fiche de l'écran numérique n°${this.produitSelect.code}`, e);
      }
      loadingComponent.close();
    },
  },
};

</script>

<style scoped>
  .distance{
    margin-left: 0px;
    margin-top: 0px;
  }

  .columns{
    margin:0px;
  }

  .information {
    font-size:14px;
  }

  .information-title {
    margin-left:10px;
    margin-bottom:0;
  }

  .arrow {
    height: 50vh;
  }

  .fiche {
    position: fixed;
    z-index: -1;
  }
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteNumerique/recherche/cartographie/infoWindowMap.vue